const GL_COVERAGE_DICT = {
  coverage_gl: {
    desc: 'General Liability',
  },
} as const;

export default GL_COVERAGE_DICT;
